const ConexReducer=(state, action) => {
	const { payload, type } = action;
	switch (type) {
		case 'SET_TIPO_USUARIO':
			return {
				...state,
				tipo_usuario: payload,
			};
		case 'SET_ID_USUARIO':
			return {
				...state,
				id_usuario: payload,
			};
		case 'SET_CODIGO_ENTIDAD':
			return {
				...state,
				codigo_entidad: payload,
			};
		case 'SET_JWT':
			//desencripto el token y si es inválido paylod se sobreescribe con ''
			let perfil=''
			try {perfil=JSON.parse(window.atob(payload.split('.')[1]))
			}
			catch (error){
				perfil=''
			}
			if (payload==='' || perfil===''){//borramos el token
				localStorage.removeItem('token')
				return{
					...state,
					codigo_entidad: null,
					tipo_usuario: null,
					departamento:null,
					id_usuario: null,
					nif_usuario: null
				}
			} 
			// ok guardamos token y el perfil
			localStorage.token=payload// lo guardamos tb localmente
			return{
				...state,
				tipo_usuario: perfil.tipo_usuario,
				id_usuario: perfil.id,
				departamento: perfil.departamento,
				codigo_entidad: perfil.cod_ent,
				nif_usuario: perfil.nif_usuario
			}

		default:
			return state;
	}
};
export default ConexReducer;